import React, { useState } from "react";
import type { NextStep } from "@sscs/static-metadata";
import { RemediationSteps as CommonRemediationSteps } from "@sscs/report/ui";
import { Card, Carousel, LoadingDots } from "@sscs/ui";
import { useGetReportMappingsQuery } from "Services";
import styles from "./details.module.scss";

type RemediationStepsProps = { steps: Record<string, NextStep[]> | undefined };

const RemediationSteps = ({
  steps,
}: RemediationStepsProps): React.JSX.Element | null => {
  const { data: reportMappings } = useGetReportMappingsQuery();
  const [carouselIndex, setCarouselIndex] = useState(0);
  const violations = Object.keys(steps ?? {});
  const currentViolation =
    violations.length > 0 ? violations[carouselIndex] : null;

  if (steps && Object.keys(steps).length === 0) {
    return null;
  }

  return (
    <Card.Card>
      <Card.Title>Remediation steps</Card.Title>
      <Card.Content>
        {steps && currentViolation !== null ? (
          <>
            <div className={styles.policy}>
              {currentViolation} -{" "}
              {reportMappings?.descriptions[currentViolation]}
            </div>
            <div className={styles["remediation-steps"]}>
              <CommonRemediationSteps steps={steps[currentViolation]} />
            </div>
          </>
        ) : (
          <LoadingDots />
        )}
      </Card.Content>
      {violations.length > 1 && (
        <Card.Actions>
          <Carousel
            activeIndex={carouselIndex}
            itemsCount={violations.length}
            onChange={setCarouselIndex}
          />
        </Card.Actions>
      )}
    </Card.Card>
  );
};

export default RemediationSteps;
